module.exports = __webpack_public_path__ + "img/rouler_positions_2.5d3b4529.png";